<script>
import Button from '@/components/Button';
import { mapGetters, mapActions } from 'vuex';

export default {
  name: 'Order',
  components: {
    Button,
  },
  props: {
    limit: {
      type: Number,
    },
    price: {
      type: String,
    },
    paymentTokenIcon: {
      type: String,
    },
    show: {
      type: Boolean,
    },
  },
  data() {
    return {
      quantity: 0,
      loading: false,
    };
  },
  computed: {
    ...mapGetters('Presale', [
      'paymentTokenName',
      'userTokensCount',
      'allowance',
      'supply',
      'userTokensTotal',
      'userCardLimit',
    ]),
    total() {
      return this.$BN(this.quantity * this.$contracts.fromWei(this.price));
    },
    priceToShow() {
      return this.$contracts.fromWei(this.price);
    },
    approved() {
      // if (this.userTokensCount < this.limit) { return false; }
      return this.$BN(this.$contracts.toWei(this.total)).lte(this.allowance);
    },
    cardsLeft() {
      return Number(this.supply?.maxTotalSupply) - Number(this.supply?.currentSupply);
    },
    userCardLimitExceed() {
      return (
        this.userTokensTotal >= this.limit
        || this.quantity + this.userTokensCount >= this.userCardLimit
      );
    },
  },
  methods: {
    ...mapActions({
      approveToken: 'Presale/approveToken',
      register: 'Presale/registerForPreSale',
      allowanceCheck: 'Presale/allowanceToken',
      updateLimit: 'Presale/getUserLimits',
      updateTotalLimit: 'Presale/getUserLimitsTotal',
    }),
    async approve() {
      try {
        this.loading = true;
        await this.approveToken(
          this.$contracts.toWei(this.$BN(this.total).times(this.limit).toString()),
        );
        this.loading = false;
        this.allowanceCheck();
      } catch (e) {
        console.log(e);
        this.loading = false;
      }
    },
    async registerSale() {
      try {
        this.loading = true;
        await this.register(this.quantity);
        this.quantity = 0;
        this.updateLimit();
        this.updateTotalLimit();
        this.loading = false;
      } catch (e) {
        console.log(e);
        this.loading = false;
      }
    },
    getPayTokenIcon() {
      // eslint-disable-next-line global-require,import/no-dynamic-require
      return require(`@/assets/img/${this.$chain.getName()}/launchpad/${
        this.paymentTokenIcon
      }.png`);
    },
  },
};
</script>

<template>
  <div class="upcoming-card main-block my-5 text-center" :class="{ 'main-block--blurred': !show }">
    <v-row>
      <v-col cols="12" md="6" class="d-none d-md-flex align-center justify-center">
        <img src="@/assets/img/launchpad/card_example.png" alt="" />
      </v-col>
      <v-col cols="12" md="6">
        <div class="order main-block">
          <div class="order__title">
            <div class="order__price">Price</div>
            <div>
              <div class="order__price-amount">{{ priceToShow | amount(2, false, 2) }}</div>
              <div class="order__price-currency">
                <img :src="getPayTokenIcon()" alt="ic-milk2" />{{ paymentTokenName }}
              </div>
            </div>
          </div>
          <div class="order__input">
            <Button class="btn--round" @click="--quantity" :disabled="quantity <= 0">-</Button>
            <div>{{ quantity }}</div>
            <Button
              class="btn--round"
              @click="++quantity"
              :disabled="
                quantity >= limit - userTokensCount || quantity >= cardsLeft || userCardLimitExceed
              "
              >+</Button
            >
          </div>
        </div>
        <div class="order__total">
          <div class="order__total-price">
            <div>total price:</div>
            <div>
              <img :src="getPayTokenIcon()" alt="ic-milk2" />{{ total | amount(2, false, 2) }}
            </div>
          </div>
          <div class="order__total-quantity mb-5">
            <div>Number of cards</div>
            <div v-if="quantity === 1">{{ quantity }} CARD</div>
            <div v-else>{{ quantity }} CARDS</div>
          </div>
          <Button @click="approve" v-if="!approved" :loading="loading">Approve</Button>
          <Button @click="registerSale" :loading="loading" :disabled="quantity < 1" v-else
            >Buy</Button
          >
        </div>
      </v-col>
    </v-row>
    <div class="order__overlay" v-if="!show"></div>
  </div>
</template>

<style lang="scss">
.order {
  padding: 3rem;

  &__title {
    display: flex;
    font-weight: 600;
    font-size: 2.2rem;
    justify-content: space-between;
    margin-bottom: 3rem;
  }

  &__price {
  }

  &__price-amount {
    font-size: 2.6rem;
  }

  &__price-currency {
    text-align: right;
    font-weight: 500;
    font-size: 1.6rem;

    img {
      height: 1em;
      margin-right: 0.5em;
    }
  }

  &__input {
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: $input-bg;
    box-shadow: $input-shadow;
    border-radius: 4.6rem;
    height: 7rem;
    position: relative;
    font-size: 2.5rem;
    font-weight: 700;

    .btn--round {
      height: 6.5rem;
      width: 6.5rem;
      padding: 0;
      font-size: 2.5rem;
    }

    body.binance & {
      background: $b-input-bg;
      box-shadow: $b-input-shadow;
    }
  }

  &__total {
    margin: 3rem 0;

    &-price {
      display: flex;
      justify-content: space-between;
      font-size: 2.2rem;
      font-weight: 700;
      text-transform: uppercase;

      img {
        height: 2rem;
        margin-right: 1rem;
        vertical-align: middle;
      }
    }

    &-quantity {
      display: flex;
      justify-content: space-between;
      font-size: 1.8rem;
      font-weight: 500;
    }
  }

  &__overlay {
    position: absolute;
    content: '';
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    opacity: 0.05;
    background: #000;
    border-radius: 2.8rem;
  }
}
</style>
